import {Loading} from '@ds/components';

type LoadingOverlayProps = {
  loading: number | boolean;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({loading}) => {
  const isLoading =
    (typeof loading === 'number' && loading > 0) || (typeof loading === 'boolean' && loading);

  if (!isLoading) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      role="status"
      aria-label="در حال بارگذاری"
    >
      <div className="size-15">
        <Loading size="medium" color="primary" />
      </div>
    </div>
  );
};

export default LoadingOverlay;
